import { Dialog } from "@sortera/react-components";
import { CreateProject } from "./create-project.tsx";
import styles from "./create-project.module.css";

/**
 * "Skapa projekt" as a pop-up over the page it was asked for on. Closing it while the Factory runs
 * stops only the waiting here — the run carries on, and the project appears in the list when done.
 */
export function CreateProjectDialog({
  open,
  onOpenChange,
  defaultEmail,
  onCreated,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  defaultEmail: string;
  onCreated: (repo: string) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <Dialog.Content className={styles.dialog} title="Skapa projekt" closeLabel="Stäng">
        <Dialog.Body>
          <CreateProject defaultEmail={defaultEmail} onCreated={onCreated} />
        </Dialog.Body>
      </Dialog.Content>
    </Dialog>
  );
}
